export const selectAssignableUsers = (state) => state.assignees.assignableUsers;

export const selectIsAssignableUsersLoading = (state) =>
  state.assignees.isAssignableUsersLoading;
